import React from 'react';
import './RatingSummary.scss';

export const ReviewsCount = ({ totalCount }: { totalCount: string }) => {
    return (
        <p className="reviews-count eds-text-bs">{`${totalCount} reviews`}</p>
    );
};
